<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @open-detail="openDetail"
    >
      <div slot="header" class="d-flex">
        <PageHeader
          ref="header"
          style="width: 100%;min-width: 250px; max-width: 600px;"
          @query="getData"
          @reset="resetPage"
        />
        <div class="vxe-button--opts">
          <b-button
            v-if="allow('A')"
            size="sm"
            variant="outline-success"
            @click="addVisible = true"
          >
            {{ $l('btn_add') || '新增部门' }}
          </b-button>
        </div>
      </div>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <AddSector :visible.sync="addVisible" @reload="reload" />

    <SectorForm
      :visible.sync="detailOpts.visible"
      :costSectorCode="detailOpts.costSectorCode"
    />
  </div>
</template>

<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main.vue'
import PageHeader from './header.vue'
import AddSector from '../add-sector'
import SectorForm from '../sector-form'
export default {
  components: { PageMain, PageHeader, AddSector, SectorForm },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      addVisible: false,
      detailOpts: { visible: false, costSectorCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterCustomerCostSectorListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetail({ costSectorCode }) {
      this.detailOpts = { visible: true, costSectorCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.vxe-button--opts {
  margin: 0 12px;
  min-width: max-content;
}
// .clearable-button {
//   .el-icon-circle-close {
//     display: none;
//   }
// }
// .clearable-button.clearable:hover {
//   .el-icon-circle-close {
//     display: inline-block;
//     z-index: 999;
//   }
//   .el-icon-circle-close:hover {
//     transform: scale(1.2);
//   }
// }
</style>
